module.exports = __webpack_public_path__ + "static/media/DAI.f7ae4041.svg";


//////////////////
// WEBPACK FOOTER
// ./src/App/components/CoinCircle/icons/DAI.svg
// module id = 1506
// module chunks = 85